import { render, staticRenderFns } from "./contentCourseLiveAddImage.vue?vue&type=template&id=a163a2a8&"
import script from "./contentCourseLiveAddImage.vue?vue&type=script&lang=js&"
export * from "./contentCourseLiveAddImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports